// extracted by css-extract-rspack-plugin
export default {"triggerChip":"triggerChip-QmJfCy","popoverContent":"popoverContent-ApbDRC","popoverHeader":"popoverHeader-t3XDdc"};